import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetBijbEventAction implements Action {
  public static readonly type = 'GetBijbEventAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetBijbEventAction.type;
}
